import { useSelector } from "react-redux";

import {
    selectIsContactsFullAccess,
    selectIsContactsPendingApproval,
    selectIsContactsReadonly,
} from "app/pages/sales-intelligence/sub-modules/contacts-tab/store/selectors";

import {
    selectNumberOfContactsSearchResults,
    selectRemainingQuota,
    selectSearchResultsAreFetching,
} from "../../../store/selectors";

import RevealActionButton from "./RevealActionButton";
import withApproveTermsGuard from "app/pages/sales-intelligence/sub-modules/contacts-search/hoc/withApproveTermsGuard";

type RevealActionButtonProps = {
    onClick(): void;
    onApprove?: () => Promise<unknown> | undefined;
};

const RevealActionButtonGuard = withApproveTermsGuard(RevealActionButton);

const LeadGenRevealActionButtonContainer = (props: RevealActionButtonProps) => {
    const remainingRevealQuota = useSelector(selectRemainingQuota);
    const areSearchResultsFetching = useSelector(selectSearchResultsAreFetching);
    const numberOfResults = useSelector(selectNumberOfContactsSearchResults);
    const isContactsRevealAccess = useSelector(selectIsContactsFullAccess);
    const isContactReadonlyAccess = useSelector(selectIsContactsReadonly);
    const isContactsPendingApproval = useSelector(selectIsContactsPendingApproval);

    return (
        <RevealActionButtonGuard
            remainingRevealQuota={remainingRevealQuota}
            areSearchResultsFetching={areSearchResultsFetching}
            numberOfResults={numberOfResults}
            isContactsRevealAccess={isContactsRevealAccess}
            isContactReadonlyAccess={isContactReadonlyAccess || isContactsPendingApproval}
            onClick={props.onClick}
            onApprove={props.onApprove}
        />
    );
};

export default LeadGenRevealActionButtonContainer;
